const checkEgiftcard = conf => {
    if (conf.length === 0 || !Array.isArray(conf)) {
        return null;
    }

    const attributes = [
        'recipientName',
        'recipientEmail',
        'senderName',
        'deliveryDate',
        'deliveryTime',
    ];

    const entry = conf.reduce((acc, item) => {
        if (attributes.includes(item.configurationLabel) && item.configuratorType === 'EGIFTCARD') {
            acc[item.configurationLabel] = item.configurationValue;
        }
        return acc;
    }, {});

    const check = attributes.filter(e => typeof entry[e] === 'undefined');
    return check.length > 0 ? null : entry;
};

export { checkEgiftcard };
